import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSessionStore } from '@/stores/useSessionStore'
import { isInitialPasswordSetupDeadlinePassed } from '../lib/initial-password-setup'

/** After signup verify (no password), redirect to /set-password when session TTL elapses. */
export function useInitialPasswordSetupDeadline() {
  const navigate = useNavigate()
  const pending = useSessionStore((s) => s.pendingInitialPasswordSetup)
  const deadlineMs = useSessionStore((s) => s.passwordSetupDeadlineMs)
  const passwordSetupRequired = useSessionStore((s) => s.passwordSetupRequired)
  const firedRef = useRef(false)

  useEffect(() => {
    firedRef.current = false
  }, [pending, deadlineMs])

  useEffect(() => {
    if (!pending || deadlineMs == null || passwordSetupRequired) return

    const fireRedirect = () => {
      if (firedRef.current) return
      firedRef.current = true
      useSessionStore.getState().setPasswordSetupRequired(true)
      navigate('/set-password', { replace: true })
    }

    if (isInitialPasswordSetupDeadlinePassed(deadlineMs)) {
      fireRedirect()
      return
    }

    const remaining = deadlineMs - Date.now()
    const timerId = globalThis.setTimeout(fireRedirect, remaining)
    return () => globalThis.clearTimeout(timerId)
  }, [pending, deadlineMs, passwordSetupRequired, navigate])
}
